import { graphql } from "../generated";

export const NOTIFICATIONS_COUNT = graphql(`
  query NotificationsCount {
    notificationsCount
  }
`);
